import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalBase, language, notification, color } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';
import { files } from '@task-utils/utils';
import { AccordionListComponent } from '@task-components/task-accordion-list.comopnent';
import { User } from '@task-modules/users';


@Component({
    selector: 'task-import-scheduled-order-service-dialog',
    template: `
        <h2 class="modal-title" style="margin-bottom: 1.2em;">{{ "SUPPLIER.IMPORT_SERVICE" | trans }}</h2>
        
        <details style="box-shadow: none; grid-column: 1 / -1; padding-left: 0; padding-right: 0; border-bottom: 1px solid rgba(var(--background-dark));  margin-top: 0px; ">
            <summary style="">
                <h3 style="margin-bottom: 0.3em; font-size: .89em;" class="uppercase flex-row align-center">
                    <i icon="info_outline" style="font-size: .7em;5 display: inline-block; margin-right: .5em;"></i>
                    <span>{{"SUPPLIER.IMPORT_DOWNLOAD_SERVICE" | trans}}</span>
                </h3>
            </summary>
             <ul>
                <li>{{'ERROR.DELETING_COLUMNS' | trans}}</li>
                <li>{{'ERROR.ADDING_COLUMNS' | trans}}</li>
                <li>{{'ERROR.HIDDING_COLUMNS' | trans}}</li>
                <li>{{'ERROR.REQUIRED_FIELDS' | trans}}</li>
                <li>{{'ERROR.PLANNED_DATE' | trans}} &nbsp; <b>DD.MM.GGGG.</b></li>
                <li>{{'ERROR.DROP_DOWN_VALUES' | trans}}</li>
                <li>{{'ERROR.WORK_HIERARCHY_ORDER' | trans}}</li>
             </ul>
        </details>

        <div *ngIf="can_pick_company_id" style="padding-top: 1em;">
            <knw-auto-search
                #company_picker
                [required]="true"
                [function]="search_companies"
                [to-label]="format_location_name"
                label="{{ 'COMPANY' | trans }}"
                [multi]="false"
                [(ngModel)]="company"
                classes="outlined">
            </knw-auto-search>
        </div>
        
        <div style="">
            <div *ngIf="!msgs.showMsg" class="flex-row justify-space-around" style="margin-top: 1.5em;">
                <button class="filled"
                    color="secondary"
                    (click)="download()"
                    [disabled]="!company || !company.company_id">
                    <i icon="file_download"></i>
                    <span>{{ 'SUPPLIER.DOWNLOAD' | trans }}</span>
                </button>
                <button class="filled"
                    color="primary"
                    (click)="getFile()"
                    [disabled]="!company || !company.company_id">
                    <i icon="file_upload"></i>
                    <span>{{ 'SUPPLIER.IMPORT' | trans }}</span>
                </button>
            </div>
        </div>
        
        <div *ngIf="msgs.showMsg" class="info-msg" style="">
            <p style="color:rgb(var(--{{msgs.msg_color}})); white-space: pre-wrap;">{{ msgs.msg }}</p>
        </div>
        
        <div class="flex-row flex-static justify-end modal-footer">
            <button color="primary"
                    (click)="cancel()">
                <i icon="clear"></i>
                <span>{{ 'CLOSE' | trans }}</span>
            </button>
        </div>
       
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../../pricelists/pricelists.scss']
})
export class ImportScheduledOrderServiceDialog extends ModalBase<Task.Supplier, any> {
    @ViewChild(AccordionListComponent)

    preventSoftClose = true;
    file: files.IFile[];

    can_pick_company_id = false
    @Input()
    company: Partial<Task.Company> = {
        company_id: null
    };

    ngOnInit() {
        this.init()
    }

    format_location_name(company: Task.Company) {
        if (!company) { return ""; }
        return `${company.name ?? ''}`;
    }

    async search_companies() {
        let res = await TaskRoutes.companies.api_company_search(
            { search: [Task.COMPANY_TYPE.MAIN], attributes: ["#=:company_type_id"] },
            { page_no: 1, page_size: 10 }
        )
        return res.data;
     }


    async init() {
        let user = await User.currentUserPromise;
        this.can_pick_company_id = user.user_type_id === Task.USER_TYPE.SYSTEM_ADMIN

        if (!this.can_pick_company_id) {
            this.company.company_id = user.company_id;
        }
    }

    msgs = {
        msg: language.translate("SUPPLIER.SUCCESS"),
        showMsg: false,
        msg_color: 'secondary-dark'
    };

    async download() {
        await TaskRoutes.scheduled_orders.api_download_service_template_xlsx(this.company.company_id);
        this.cancel();
    }

    async getFile() {
        this.file = await files.get_files({
            multiple: false,
            accept: ".xlsx"
        });

        if (this.file) {
            try {
                await TaskRoutes.scheduled_orders.api_upload_scheduled_orders_for_service(this.company.company_id, this.file[0].file);
                this.msgs.msg_color = 'secondary-dark';
                this.msgs.showMsg = true;
            } catch (error) {
                console.error(error);

                const error_map: Record<string, string> = {
                    "Title is required": "ERROR.TITLE_REQUIRED",
                    "Description is required": "ERROR.DESCRIPTION_REQUIRED",
                    "Location not found": "ERROR.LOCATION_NOT_FOUND",
                    "Work hierarchy not found": "ERROR.WORK_HIERARCHY_NOT_FOUND",
                    "Wrong frrequency": 'ERROR.WRONG_FREQUENCY',
                    "Frequency is required": 'ERROR.FREQUENCY_REQUIRED',
                    "First service date from is required": 'ERROR.FIRST_SERVICE_DATE_FROM_REQUIRED',
                    "First service date to is required": 'ERROR.FIRST_SERVICE_DATE_TO_REQUIRED',
                    "End date is required": 'ERROR.END_DATE_REQUIRED',
                    "Wrong planned_start_date format": "ERROR.WRONG_PLANNED_START_DATE_FORMAT",
                    "Wrong planned_end_date format": "ERROR.WRONG_PLANNED_END_DATE_FORMAT",
                    "Wrong cut_date format": "ERROR.WRONG_CUT_DATE_FORMAT",
                    'planned_start_date needs to be before planned_end_date': 'ERROR.PLANNED_START_DATE_NEEDS_TO_BE_BEFORE_PLANNED_END_DATE',
                    'cut_date needs to be after planned_end_date': 'ERROR.CUT_DATE_NEEDS_TO_BE_AFTER_PLANNED_END_DATE',
                    'wrong mobile': 'ERROR.WRONG_MOBILE',
                    "Supplier not found": "ERROR.SUPPLIER_NOT_FOUND",
                    'cost_estimate needs to be float': 'ERROR.COST_ESTIMATE_NEEDS_TO_BE_FLOAT'
                };

                if (error.data) {
                    const translated_errors: Record<string, string[]> = {};

                    Object.entries(error.data as Record<string, string[]>).forEach(([row, messages]) => {
                        translated_errors[row] = messages.map(message => {
                            const translation_key = error_map[message];
                            return translation_key ? language.translate(translation_key) : message;
                        });
                    });

                    const error_string_row: Record<string, string> = {};
                    Object.entries(translated_errors).forEach(([row, messages]) => {
                        error_string_row[row] = messages.join(", ");
                    });

                    const error_message = Object.entries(error_string_row)
                        .map(([row, message]) => `Red ${row}: ${message}`)
                        .join('\n');

                    notification.show({
                        icon: "error",
                        color: color.Variable.warn,
                        title: language.translate('ERROR.VALIDATION'),
                        message: error_message,
                    });
                } else {
                    notification.show({
                        icon: "error",
                        color: color.Variable.warn,
                        title: language.translate('ERROR'),
                        message: language.translate('ERROR.GENERIC_TEXT')
                    });
                }
            }
        }
    }
    
    cancel() {
        this.submit(null);
    }
}
